import React from 'react';
import { CheckCircle, Warning } from 'phosphor-react';
import { COLORS } from '../../utils/colors';

const JobSavingSuccess = ({
  type,
  title,
  details,
}: {
  type: 'Success' | 'Error';
  title: string;
  details: string;
}) => {
  const isSuccess = type === 'Success';

  return (
    <div className="flex items-center justify-center w-full min-h-[60vh] px-4 py-10">
      <div className="flex flex-col items-center text-center max-w-sm w-full">
        {/* Icon circle */}
        <div
          className="flex items-center justify-center w-24 h-24 rounded-full mb-6"
          style={{
            background: isSuccess ? COLORS.SUCCESS_100 : COLORS.ERROR_100,
          }}>
          <div
            className="flex items-center justify-center w-16 h-16 rounded-full"
            style={{
              background: isSuccess ? COLORS.SUCCESS_200 : COLORS.ERROR_200,
            }}>
            {isSuccess ? (
              <CheckCircle size={40} weight="fill" color={COLORS.SUCCESS_600} />
            ) : (
              <Warning size={40} weight="fill" color={COLORS.ERROR_500} />
            )}
          </div>
        </div>

        {/* Text */}
        <h2 className="text-xl md:text-2xl font-bold GREY_900-CLR mb-3">{title}</h2>
        <p className="text-sm md:text-base GREY_500-CLR leading-relaxed">{details}</p>

        {/* Subtle divider accent */}
        <div
          className="mt-8 h-1 w-16 rounded-full"
          style={{ background: isSuccess ? COLORS.SUCCESS_400 : COLORS.ERROR_300 }}
        />
      </div>
    </div>
  );
};

export default JobSavingSuccess;
